<template>
  <generic-container
    icon="file alternate"
    :title="$t('intercable billing')"
    :configurable="true"
    :show_back="true"
    :show_refresh="true"
    @refresh="init"
    :header_buttons="header_buttons"
    @configure="configure"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <!-- <th>{{ $t("create date") }}</th> -->
          <th>{{ $t("name") }}</th>
          <!-- <th>{{ $t("immediate superior") }}</th>
          <th>{{ $t("area") }}</th>
          <th>{{ $t("job position") }}</th>
          <th>{{ $t("id number") }}</th>
          <th>{{ $t("users") }}</th> -->
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <!-- <staff-modal ref="staff_modal" @success="init" /> -->
    <configure-modal ref="configure_modal" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  init_ajax_data_datables,
  enterprise_setup,
  register_listener,
  error_toast,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
// import ConfigureModal from "./configuration_modal/Index.vue";
import ConfigureModal from "./configuration_modal/Index.vue";
// import StaffModal from "./staff_modal/Index.vue";
// import LinkReviewModal from "./link_review_modal/Index.vue";
// import { quotas } from "./quotas.js";

// @ is an alias to /src
export default {
  name: "IntercableBillingIndex",
  components: {
    "generic-container": GenericContainer,
    // StaffModal,
    ConfigureModal,
    // LinkReviewModal,
  },
  filters: filters,
  data() {
    return {
      // configure_modal: ConfigureModal,
      datatable: {},
      header_buttons: [
        // {
        //   icon: "cubes",
        //   click: this.go_bulk,
        //   tooltip: this.$t("bulk process"),
        // },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    configure() {
      let vm = this;
      vm.$refs.configure_modal.show_modal();
    },
    add() {
      let vm = this;
      vm.$refs.staff_modal.show_modal();
    },
    init() {
      let vm = this;
      let columns = [
        // {
        //   data: function (row) {
        //     return filters.formatDate(
        //       row.create_date,
        //       vm.enterprise_setup.detailed_date_format,
        //     );
        //   },
        // },
        // {
        //   data: function (row) {
        //     let name = "";
        //     if (row.first_name) name += row.first_name;
        //     // if (row.second_name) name += ` ${row.second_name}`;
        //     if (row.surname) name += ` ${row.surname}`;
        //     // if (row.second_surname) name += ` ${row.second_surname}`;
        //     return name;
        //   },
        // },
        // {
        //   data: function (row) {
        //     if (row.immediate_superior_staff_object) {
        //       let name = "";
        //       if (row.immediate_superior_staff_object.first_name)
        //         name += row.immediate_superior_staff_object.first_name;
        //       // if (row.immediate_superior_staff_object.second_name)
        //       //   name += ` ${row.immediate_superior_staff_object.second_name}`;
        //       if (row.immediate_superior_staff_object.surname)
        //         name += ` ${row.immediate_superior_staff_object.surname}`;
        //       // if (row.immediate_superior_staff_object.second_surname)
        //       //   name += ` ${row.immediate_superior_staff_object.second_surname}`;
        //       return name;
        //     } else return "";
        //   },
        // },
        // {
        //   data: function (row) {
        //     if (row.multimoney_staff_area) {
        //       return row.multimoney_staff_area.name;
        //     } else return "";
        //   },
        // },
        // {
        //   data: function (row) {
        //     if (row.multimoney_staff_job_position) {
        //       return row.multimoney_staff_job_position.name;
        //     } else return "";
        //   },
        // },
        {
          data: function (row) {
            return JSON.stringify(row, null, 2);
          },
        },
        {
          data: function (row) {
            let r = "";
            r += `<div class="ui mini icon basic button" data-tooltip="${vm.$t(
              "details",
            )}" onclick="window.dispatchEvent(new CustomEvent('intercable_billing_watch', { detail: { uuid: '${
              row.uuid
            }'}}))">
                      <i class="blue eye icon"></i>
                  </div>
                  <div class="ui mini icon basic button" data-tooltip="${vm.$t(
                    "delete",
                  )}" onclick="window.dispatchEvent(new CustomEvent('intercable_billing_delete', { detail: { uuid: '${
              row.uuid
            }'}}))">
                      <i class="red trash icon"></i>
                    </div></div>`;
            return r;
          },
        },
        // {
        //   data: function (row) {
        //     return "<pre>" + JSON.stringify(row, null, 2) + "</pre>";
        //   },
        // },
        // {
        //   data: function (row) {
        //     let r = "";
        //     r += `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('run_monitor', { detail: { uuid: '${row.uuid}'}}))">
        //               <i class="eye icon"></i>
        //             </div>`;
        //     return r;
        //   },
        // },
      ];

      let onSelect = (/* data */) => {
        // vm.$refs.staff_modal.show_modal(data.uuid);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["intercable billing url"],
        columns,
        onSelect,
      );

      /** Register listeners */
      register_listener("intercable_billing_watch", function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        let uuid = e.detail.uuid;
        console.log("show modal", uuid);
        // vm.$refs.transaction_modal.show_modal({ uuid });
      });

      register_listener("intercable_billing_delete", function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        let uuid = e.detail.uuid;
        vm.$alertify.confirm(
          vm.$t("are you sure to remove bill?"),
          function () {
            local_api(vm, "post", "/intercable_billing/bill/do-remove", {
              i: uuid,
            })
              .then(() => {
                vm.init();
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
};
</script>
